import React, { useMemo } from 'react';
import AssistantChat from './AssistantChat';
import { universalChatConfig } from './assistantChatConfigs';

function UniversalChat(props: { agent?: string; data?: any; showAgent?: boolean }) {
  const config = useMemo(
    () => universalChatConfig(props),
    [props.agent, props.data, props.showAgent]
  );
  return <AssistantChat config={config} />;
}

export default UniversalChat;
